import { crumbsFor } from '@utils/route'
import { useTranslation } from '@/i18n'

/**
 * 認証済シェル内の各 route 用 placeholder。
 * Phase 3 後半 (T-E/T-F/T-G 等) で本物の screen に置き換える前段の中身。
 *
 * crumbsFor の最終要素 (i18n key、もしくは raw id) を画面タイトルとして使う
 * (Topbar との視覚一貫性)。i18n key は t() で表示文字列に解決し、key として
 * 登録が無い文字列はそのまま表示される (i18n fallback)。
 */
export interface ScreenPlaceholderProps {
  route: string
}

const lastSegment = (route: string): string => {
  const crumbs = crumbsFor(route)

  return crumbs[crumbs.length - 1] ?? route
}

export const ScreenPlaceholder = ({ route }: ScreenPlaceholderProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="page-head" data-testid="screen-placeholder">
      <div className="ph-top">
        <div>
          <h1>{t(lastSegment(route))}</h1>
          <div className="ph-sub">{t('common.placeholder.screen_sub', { route })}</div>
        </div>
      </div>
    </div>
  )
}
